import Handler from './Handler';

export type ChannelDestination =
    | 'startOrderColumnsStream'
    | 'startExpertiseByOrderIdsStream'
    | 'startFillsGraphByOrderIdOrSymQtyStream'
    | 'startHistPriceVolStream'
    | 'startIntradayProfilesStream'
    | 'startLiquidityStream'
    | 'startOrderVolumeCurveStream'
    | 'startPLGraphStream'
    | 'startPortfolioReturnsStream'
    | 'startParmUpdates'
    | 'startPfeStream'
    | 'startPriceChartStream'
    | 'startObvChartStream'
    | 'startRsiStream'
    | 'startStrategyParamsCurByOrderIdsStream'
    | 'startStrategyParamsHistByOrderIdsStream'
    | 'startTxImpactStream'
    | 'startVenueAnalysisByOrderIdsStream'
    | 'startVenueAnalysisByOrderIdsOrSymbolStream'
    | 'startVolumeCurveStream'
    | 'startOpenSubmissionsByOrderIdsStream'
    | 'symbolInfo'
    | 'startSymbolTilesStream'
    | 'INIT'
    | 'resend'
    | 'renew';

export const channelReusesRequestId = (d: ChannelDestination) =>
    d === 'startOrderColumnsStream' || d === 'startSymbolTilesStream';

export interface RequestInfo<TRequestPayload, TResponsePayload> {
    id: number;
    destination: ChannelDestination;
    correlationId: string;
    payload: TRequestPayload;
    sentTime: Date;
    receivedCount: number;
    firstReceivedTime?: Date;
    lastReceivedTime?: Date;
    latestResponses: {
        receivedTime: Date;
        messageNumber: number;
        payload: TResponsePayload;
    }[];
    status: 'Sending' | 'Sent' | 'Error';
}

export default interface Channel<TRequestPayload, TResponsePayload> {
    id: number;

    destination: ChannelDestination;

    isActive: boolean;

    createdDate: Date;

    handler: Handler<TResponsePayload>;

    latestRequests: RequestInfo<TRequestPayload, TResponsePayload>[];

    sentCount: number;

    firstSentTime?: Date;

    lastSentTime?: Date;
}

export type ChannelInfo = Omit<Channel<unknown, unknown>, 'handler'> & {
    destination?: ChannelDestination;
};

export const toStopDestination = (c: ChannelDestination | string) =>
    c.replace('start', 'stop') as ChannelDestination;
